import React from 'react';
import NemCtrl from './NemCtrl.js';

const constants = {
  colorRed: '#d62631',
  colorWhite: '#ffffff',
  colorGray: '#dedede',
  colorDarkGray: '#888888',
};

export default class RothTextInput extends NemCtrl {
  style = {
    default: {
      textAlign: 'center',
      width: '100%',
      boxSizing: 'border-box',
      fontSize: '16px',
      fontWeight: '400',
      height: '45px',
      margin: '7px 0px',
      border: '2px solid black',
      borderRadius: '22px',
      background: this.props.disabled ? constants.colorGray : constants.colorWhite,
      color: this.props.disabled ? constants.colorDarkGray : constants.colorRed,
      fontFamily: "'Molengo', sans-serif",
    },
  };
  handleChange = event => {
    this.setState({ val: event.target.value });
    if ('fn' in this.props) {
      if ('param' in this.props && 'value' in this.props) this.props.fn(this.props.param, event.target.value);
      else if ('param' in this.props) this.props.fn(this.props.param);
      else if ('value' in this.props) this.props.fn(event.target.value);
      else this.props.fn();
    }
  };
  render = () => {
    var input = (
      <input
        onFocus={evt => evt.target.setAttribute('placeholder', '')}
        onBlur={evt => evt.target.setAttribute('placeholder', this.props.placeholder)}
        style={Object.assign({}, this.getStyle(), this.props.children !== undefined ? { width: '60%' } : {})}
        type={this.props.type === 'password' ? 'password' : 'text'}
        value={this.props.value}
        placeholder={this.props.placeholder}
        onChange={this.handleChange}
        disabled={this.props.disabled}
      />
    );
    return this.props.children !== undefined ? (
      <label style={{ display: 'block' }}>
        <div style={{ width: '36%', paddingRight: '10px', display: 'inline-block' }}>{this.props.children}</div> {input}
      </label>
    ) : (
      <label style={{ display: 'block' }}>{input}</label>
    );
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/RothTextInput.js
 **/